module.exports = __webpack_public_path__ + "img/link-pocket-desktop_cn.4a34d7a.jpg";